<template>
<el-dialog
  :visible.sync="dialogVisible"
  :append-to-body="true"
  :show-close="false"
  :close-on-press-escape="false"
  :close-on-click-modal="false"
  title="因子选择"
  width="700px"
  custom-class="custom-dialog"
>
  <section>
    <div
      v-for="(dataModelList, factorName) in dataModelMap"
      :key="factorName"
    >
      <span>因子：{{factorName}}</span>
      <span
        v-for="(dataModel, index) in dataModelList"
        :key="index"
        style="margin-left:20px;"
      >
        <span>监测值：{{dataModel.value}}</span>
<!--        <el-select-->
<!--          v-model="dataModel.suffix"-->
<!--          size="mini"-->
<!--          placeholder="请选择类型"-->
<!--          style="margin-left:10px;"-->
<!--          @change="onSuffixChanged(dataModelList, dataModel, index)"-->
<!--        >-->
<!--          <el-option-->
<!--            v-for="category in categories"-->
<!--            :key="category.value"-->
<!--            :value="category.value"-->
<!--            :label="category.label"-->
<!--          />-->
<!--        </el-select>-->
        <el-radio-group
          v-model="dataModel.suffix"
          size="mini"
          style="margin-left:10px;"
          @change="onSuffixChanged(dataModelList, dataModel, index)"
        >
          <el-radio
            v-for="category in categories"
            :key="category.value"
            :label="category.value"
          >{{category.label}}</el-radio>
        </el-radio-group>
      </span>
    </div>
  </section>

  <template slot="footer">
    <el-button type="orange" style="width:100px;" @click="handlerSubmit">确定</el-button>
  </template>
</el-dialog>
</template>

<script>
export default {
  name: 'QCFactorSelectDialog',
  data () {
    return {
      dialogVisible: false,
      dataModelMap: {}
    }
  },
  computed: {
    categories: () => Object.freeze([{
      value: '',
      label: 'PAMS'
    }, {
      value: ' - TO14',
      label: 'TO14'
    }])
  },
  methods: {
    dataListChanged (dataList) {
      let categories = this.categories

      this.dataModelMap = dataList.reduce((map, data) => {
        let factorName = data.factorName
        let list = map[factorName]

        if (!list) {
          list = map[factorName] = []
        }

        let len = list.length
        data.suffix = categories[len] ? categories[len].value : ''
        list.push(data)

        return map
      }, {})

      this.dialogVisible = true
    },
    onSuffixChanged (dataModelList, dataModel, dataIndex) {
      let nextDataModel = dataModelList[dataIndex ^ 1]

      if (!nextDataModel) {
        return
      }

      let categories = this.categories
      let suffix = dataModel.suffix
      let categoryIndex = categories.findIndex(category => category.value === suffix) ^ 1
      nextDataModel.suffix = categories[categoryIndex].value
    },
    handlerSubmit () {
      let dataModelMap = this.dataModelMap
      let dataList = Object.values(dataModelMap).reduce((list, dataModelList) => dataModelList.reduce((list, dataModel) => {
        let suffix = dataModel.suffix

        if (suffix) {
          dataModel.factorName = dataModel.factorName + dataModel.suffix
          delete dataModel.suffix
        }

        list.push(dataModel)
        return list
      }, list), [])

      this.$api.QCAnalysis.updateFactorName({
        list: dataList
      }).then(() => {
        this.dialogVisible = false
        this.$emit('finished')
      }).catch(console.error)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-radio {
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/05QC-Analysis/00Data/QCFactorSelectDialog.vue